import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyA7hEQ8LnhCdDujYeD4YIxFG23Nk6JI3vY",
    authDomain: "fir-9849c.firebaseapp.com",
    projectId: "fir-9849c",
    storageBucket: "fir-9849c.appspot.com",
    messagingSenderId: "918774864805",
    appId: "1:918774864805:web:43655996cdd8fb64f4264c",
    measurementId: "G-RPBWQ2K911",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = app.firestore();

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const analytics = getAnalytics(app);

export { auth, db };
